import component from "./CoreLayout";
export default component;
